<template>
	<div class="rightInner">
		<div class="title">
			<div class="titleLine"></div>
			{{$t('mypages.collections.title')}}
		</div>
		<table>
			<thead>
				<th>{{$t('mypages.collections.th_image')}}</th>
				<th>{{$t('mypages.collections.th_brand_name')}}</th>
				<th>{{$t('mypages.collections.th_description')}}</th>
				<th>{{$t('mypages.collections.th_price')}}</th>
				<th>{{$t('mypages.collections.th_fav_time')}}</th>
				<th>{{$t('mypages.collections.th_action')}}</th>
			</thead>
			<tbody>
				<tr v-for="(item,index) in collectList" :key="item.id"   >
					<td>
						<div class="tdInner">
							<img :src="item.cover_image" class="proImg"/>
						</div>
					</td>
					<td>
						<div class="tdInner">
							<div>{{item.product_name}}</div>
							<div class="grayText">{{item.cate_name}}</div>
						</div>
					</td>
					<td>
						<div class="tdInner">
							{{item.short_intro}}
						</div>
					</td>
					<td>
						<div class="tdInner redText center">￥{{item.sale_price==null?0:item.sale_price}}</div>
					</td>
					<td>
						<div class="tdInner center">{{item.gmt_collect}}</div>
					</td>
					<td>
						<div class="tdInner center">
							<div class="addCar" @click="goBuy(item.id)">{{$t('mypages.collections.add_to_cart')}}</div>
							<div class="cancel" @click="Delete(item.collect_id)">{{$t('mypages.collections.delete')}}</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="paginationArea"><PaginationVue  :TotalCount="totalcount" :pageSize="10" @pageChenged="handlePage"></PaginationVue></div>
	</div>
</template>

<script>
	import PaginationVue from '../../components/pagination.vue';
	export default{
		components:{
			PaginationVue
		},
		data(){
			return {
				collectList:[],
				pageIndex:1,
				totalcount:1,
			}
		},
		created(){
			this.getCollectList();
		},
		methods:{			
			getCollectList() {
				this.collectList=[];
				this.$scUtil.axiosPut(this, 'CollectApi/GetCollectList', {
					pageIndex: this.pageIndex,
					pageSize:10,
					userName: localStorage.getItem('username'),
				}, res => {
					if (res.code == 100) {
						res.data.forEach(item => {
						    item.gmt_collect=this.$scUtil.dateFormatter(new Date(item.gmt_collect), 'Y-M-D');
						});
						this.collectList=res.data;
						this.totalcount=res.totalcount;
						//console.log("浏览历史:"+JSON.stringify(this.recordList))
					}
			
				});
			},
			handlePage(message) {
				console.log(message);
				this.pageIndex = message;
				this.getCollectList();
			},
			goBuy(id)
			{
				this.$router.push({name:'DetailVue',query:{id:id}})
			},
			Delete(id)
			{
					this.$confirm(this.$t('mypages.collections.confirm_delete'), this.$t('mypages.collections.confirm_title'), {
					        distinguishCancelAndClose: true,
					        confirmButtonText: this.$t('mypages.collections.confirm_confirm'),
					        cancelButtonText: this.$t('mypages.collections.confirm_cancel'),
					        type: 'warning'
					      }).then(() => {
				         try 
						 {
								this.$scUtil.axiosPost(this, 'CollectApi/Delete', {
									id:id
								}, res => {
				         		if (res.code == 100) {
				         			this.$message({
				         				message: res.message,
				         				type: "success"
				         			});
									this.getCollectList();
				         			return;
				         		}
				         
				         	});
				         } catch (error) {
				         	console.log(error);
				         }
				      }).catch(action => {
				        // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
						console.log(action)
				        if (action == 'cancel'||cation=='close') {
							console.log("执行了吗")
				          this.getCollectList();
				        }
				})
			}
		
		},
	}
	
</script>

<style scoped>
	.rightInner{
		width: 958px;	
	}
	
	
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
		background-color:#fff;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	
	.proImg{
		width: 78px;
		height: 76px;
		border: 1px solid #e9e9e9;
	}
	
	table{
		border-collapse: collapse;
		width: 100%;
	}
	
	table thead th{
		background-color: #fff;
		border-bottom: 13px solid #ebecee;
		height: 52px;
		line-height: 52px;
		font-size: 12px;
		color: #000000;
	}
	
	table tbody tr td{
		color: #333;
		font-size: 13px;
		background-color: #fff;
		padding: 20px;
		box-sizing: border-box;
		min-width: 130px;
		line-height: 25px;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.grayText{
		font-size: 12px;
		color: #888888;
	}
	
	.redText{
		color: #db050f;
	}
	
	.addCar{
		width: 82px;
		height: 26px;
		border: 1px solid #0380fe;
		color: #0380fe;
		font-size: 12px;
		cursor: pointer;
		text-align: center;
		line-height: 26px;
	}

	.cancel{
		color: #666;
		font-size: 12px;
		cursor: pointer;
	}
	
	table tbody tr td .center{
		text-align: center;
	}
	
	.paginationArea{
		display: flex;
		justify-content: center;
		background-color: #fff;
		padding: 17px 0;
	}
	
</style>